import {useCallback, useState} from "react";
import {apiV2} from "../../../api/axiosConfig";


type UploadFileResponse = {
    id: string;
    url: string;
}

export function useUploadFile(file: File|null) {
    const getUploadURL = useCallback(async () => {
        if (!file) {
            return;
        }

        const filename = file.name;

        const body =  {
            filename,
            type: file.type,
            size: file.size,
        }

        return (await apiV2.post<UploadFileResponse>("upload", body)).data;

    }, [file])

    const setUploadStatus = useCallback(async (id: string, status: string) => {
        await apiV2.patch<UploadFileResponse>(`upload/${id}`, {status});

    }, [file])

    const [error, setError] = useState<string | null>(null);

    const upload = useCallback(async () => {
        if(!file){
            setError("no file selected");
            return null;
        }
        setError(null);
        const upload = await getUploadURL();
        if (!upload) {
            setError("error uploading file");
            return null;
        }

        const {id, url} = upload;

        try {
            const response = await fetch(url, {
                method: "PUT",
                headers: {
                    "x-ms-blob-type": "BlockBlob", // REQUIRED
                    "Content-Type": file.type || "application/octet-stream",
                },
                body: file,
            });

            if (!response.ok) {
                setError("error uploading file");
                await setUploadStatus(id,"failed")
                return null
            }
        } catch (error) {
            setError("error uploading file");
            await setUploadStatus(id,"failed")
            return null

        }



        await setUploadStatus(id,"complete")
        return id;



    }, [file, getUploadURL])


    return {upload, error}


}